// AUPRÉA — Étape 30 : recommander un partenaire au client (libre choix, consentement, transparence)
import { useEffect, useState } from "react";
import axios from "axios";
import { C, Btn, Spinner, Alert } from "./shared";
import { hdrs } from "./integrationShared";
import { Logo, nomPartenaire, Chips } from "./partenairesShared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const err = (e) => e?.response?.data?.detail || "Erreur";

const Coordonnees = ({ p }) => (
  <div style={{ fontSize: 13, lineHeight: 1.6 }}>
    <strong>{nomPartenaire(p)}</strong> · {p.profession}<br />
    {[p.adresse, p.code_postal, p.ville].filter(Boolean).join(" ")}{p.telephone ? <> · <a href={`tel:${p.telephone}`}>{p.telephone}</a></> : null}{p.email ? <> · <a href={`mailto:${p.email}`}>{p.email}</a></> : null}
    {p.lien_rdv && <div><a href={p.lien_rdv} target="_blank" rel="noreferrer" style={{ color: C.blue, fontWeight: 600 }} data-testid={`reco-rdv-${p.id}`}>Prendre rendez-vous →</a></div>}
  </div>
);

const Proposition = ({ p, choisi, onChoisir, testid }) => (
  <div onClick={onChoisir} data-testid={testid} style={{ border: `1.5px solid ${choisi ? C.gold : C.border}`, background: choisi ? C.goldlt : "#fff", borderRadius: 10, padding: 10, cursor: "pointer", display: "flex", gap: 10 }}>
    <input type="radio" checked={choisi} readOnly style={{ marginTop: 4 }} />
    <Logo p={p} size={38} />
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: 600, color: C.navy }}>{nomPartenaire(p)}</div>
      <div style={{ fontSize: 12, color: C.mid }}>{p.profession}{p.ville ? ` · ${p.ville}` : ""}{p.hors_zone_visio ? " · en visio" : ""}{p.specialite_ok ? "" : " · même profession (spécialité non indiquée)"}</div>
      {p.presentation && <div style={{ fontSize: 12, marginTop: 4 }}>{p.presentation}</div>}
      <div style={{ marginTop: 4 }}><Chips items={p.specialites} /></div>
    </div>
  </div>
);

const Item = ({ it, envoyer, client }) => {
  const [choix, setChoix] = useState(""); const [ok, setOk] = useState(false); const [busy, setBusy] = useState(false);
  const p = it.propositions.find(x => x.id === choix);
  const k = it.pro.replace(/[^a-zA-Z]/g, "").slice(0, 24);
  return (
    <div data-testid={`reco-item-${k}`} style={{ border: `.5px solid ${C.border}`, borderRadius: 12, padding: 12, marginBottom: 10, background: "#fff" }}>
      <div style={{ fontWeight: 700, color: C.navy }}>{it.pro}</div>
      <div style={{ fontSize: 12, color: C.mid, margin: "2px 0 8px" }}>Sujet à aborder : {it.points.join(" · ")}</div>
      {it.recommande ? <div data-testid={`reco-fait-${k}`} style={{ background: C.teallt, borderRadius: 10, padding: 10 }}><div style={{ fontSize: 12, color: C.tealdm, fontWeight: 700, marginBottom: 4 }}>✓ Professionnel choisi · fiche de liaison transmise le {new Date(it.recommande.at).toLocaleDateString("fr-FR")}</div><Coordonnees p={it.recommande} /></div>
        : it.deja ? <div style={{ fontSize: 13, color: C.mid }} data-testid={`reco-deja-${k}`}>{client ? "Vous avez déjà votre professionnel" : "Le client a déjà son professionnel"} : <strong>{it.deja}</strong>. Aucune proposition.</div>
        : !it.propositions.length ? <div style={{ fontSize: 13, color: C.muted }} data-testid={`reco-aucun-${k}`}>Aucun partenaire AUPRÉA disponible pour le moment sur ce territoire.</div>
        : <>
          <div style={{ fontSize: 12, color: C.mid, marginBottom: 6 }}>{client ? "Choisissez librement le professionnel qui vous convient (ordre aléatoire) :" : "Présentez ces partenaires au client (ordre aléatoire) et laissez-le choisir :"}</div>
          <div style={{ display: "grid", gap: 6 }}>{it.propositions.map(x => <Proposition key={x.id} p={x} choisi={choix === x.id} onChoisir={() => { setChoix(x.id); setOk(false); }} testid={`reco-prop-${k}-${x.id}`} />)}</div>
          {p && <div style={{ marginTop: 10, background: C.gray2, borderRadius: 10, padding: 10 }}>
            <label style={{ fontSize: 13, display: "flex", gap: 8 }}><input type="checkbox" checked={ok} onChange={e => setOk(e.target.checked)} data-testid={`reco-consentement-${k}`} />
              {client ? "" : "Le client déclare : "}« J'accepte qu'AUPRÉA transmette ma fiche de liaison à {nomPartenaire(p)} pour qu'il me contacte. »</label>
            <Btn variant="gold" style={{ marginTop: 8 }} disabled={!ok || busy} onClick={async () => { setBusy(true); await envoyer(it.pro, choix); setBusy(false); }} data-testid={`reco-valider-${k}`}>Valider et transmettre la fiche</Btn>
          </div>}
        </>}
    </div>
  );
};

export const RecoPartenaires = ({ sid, token, client }) => {
  const [d, setD] = useState(null); const [msg, setMsg] = useState(null);
  const base = client ? `${API}/public/rapport-service/${token}` : `${API}/services-parcours/${sid}`;
  const cfg = client ? {} : hdrs();
  const load = () => axios.get(`${base}/recommandations`, cfg).then(r => setD(r.data)).catch(e => setMsg({ t: "error", m: err(e) }));
  useEffect(() => { load(); }, [sid, token]); // eslint-disable-line
  const envoyer = async (pro, partenaire_id) => {
    try { const r = await axios.post(`${base}/recommander`, { pro, partenaire_id, consentement: true }, cfg); setMsg({ t: "success", m: `Fiche de liaison transmise à ${r.data.partenaire} ✓ ${client ? "Ses coordonnées vous ont été envoyées par e-mail." : "Le client reçoit ses coordonnées par e-mail."}` }); load(); }
    catch (e) { setMsg({ t: "error", m: err(e) }); }
  };
  if (!d) return msg ? <Alert type="error"><span>⚠</span><span>{msg.m}</span></Alert> : <Spinner />;
  return (
    <div data-testid="reco-partenaires">
      <div style={{ fontSize: 12, color: C.mid, marginBottom: 8 }}>Territoire retenu : <strong data-testid="reco-territoire">{d.territoire}</strong></div>
      {msg && <Alert type={msg.t}><span>ℹ</span><span data-testid="reco-msg">{msg.m}</span></Alert>}
      {d.items.map(it => <Item key={it.pro} it={it} envoyer={envoyer} client={client} />)}
      <div data-testid="reco-transparence" style={{ fontSize: 12, color: C.mid, background: C.navylt, borderRadius: 10, padding: 10 }}>{d.transparence}</div>
    </div>
  );
};

export const ProsRecommandes = ({ token }) => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/public/rapport-service/${token}/recommandations`).then(r => setD(r.data)).catch(() => setD({ items: [] })); }, [token]);
  const l = (d?.items || []).filter(x => x.recommande);
  if (!l.length) return null;
  return (
    <div data-testid="pros-recommandes" style={{ marginTop: 18 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: C.golddm, textTransform: "uppercase", margin: "18px 0 6px" }}>Vos professionnels recommandés</div>
      {l.map(x => <div key={x.pro} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 12, marginBottom: 8 }}>
        <div style={{ fontSize: 12, color: C.golddm, fontWeight: 700 }}>{x.pro}</div><Coordonnees p={x.recommande} />
        <div style={{ fontSize: 13, marginTop: 6 }}><span style={{ color: C.mid }}>Sujet à aborder : </span>{x.points.join(" · ")}</div></div>)}
    </div>
  );
};
